import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  MenuItem,
  Stack,
  TextField,
} from '@mui/material';

import { CREDIT_NOTE_REASONS } from '../../../utils/creditNoteReasons';

// Dialogo para anular un comprobante: pide el sustento (Catalogo 09 de SUNAT) y una
// observacion opcional. Si SUNAT ya acepto el comprobante, el backend le envia una nota de
// credito electronica con ese sustento para darlo de baja, y solo lo anula si SUNAT la acepta
// (ver OrderController::voidInvoice); si no, el dialogo queda abierto para reintentar.
export default function VoidInvoiceDialog({ open, invoice, voiding, onClose, onConfirm }) {
  const sendsToSunat = ['aceptada', 'observada'].includes(invoice?.status);
  const [reasonCode, setReasonCode] = useState('01');
  const [observation, setObservation] = useState('');

  useEffect(() => {
    if (open) {
      setReasonCode('01');
      setObservation('');
    }
  }, [open]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Anular comprobante</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          <DialogContentText>
            ¿Seguro que deseas anular el comprobante{' '}
            <strong>
              {invoice?.type === 'factura' ? 'Factura' : 'Boleta'} {invoice?.full_number}
            </strong>
            ? El número queda registrado para la auditoría, pero podrás emitir uno nuevo para este pedido.
          </DialogContentText>
          {sendsToSunat ? (
            <Alert severity="info">
              Se enviará a SUNAT una <strong>nota de crédito electrónica</strong> por el total, con el sustento y la
              observación de abajo, para dar de baja el comprobante. Solo quedará anulado si SUNAT la acepta.
            </Alert>
          ) : (
            <Alert severity="warning">
              SUNAT no había aceptado este comprobante, así que no hay nada que dar de baja allá: se anulará solo en el
              sistema, con una nota de crédito interna.
            </Alert>
          )}
          <TextField select label="Sustento (SUNAT)" value={reasonCode} onChange={(e) => setReasonCode(e.target.value)}>
            {CREDIT_NOTE_REASONS.map((reason) => (
              <MenuItem key={reason.code} value={reason.code}>
                {reason.label}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            label="Observación (opcional)"
            multiline
            minRows={2}
            value={observation}
            onChange={(e) => setObservation(e.target.value)}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={voiding}>
          Cancelar
        </Button>
        <Button
          onClick={() => onConfirm(reasonCode, observation.trim() || null)}
          color="error"
          variant="contained"
          disabled={voiding}
        >
          {voiding ? (sendsToSunat ? 'Enviando a SUNAT...' : 'Anulando...') : 'Anular'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

VoidInvoiceDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  invoice: PropTypes.object,
  voiding: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

VoidInvoiceDialog.defaultProps = {
  invoice: null,
  voiding: false,
};
